import React from 'react';
import styled from 'styled-components';
const IconCheck = require('react-icons/lib/md/check');
const IconCancel = require('react-icons/lib/md/close');
const IconContact = require('react-icons/lib/md/perm-phone-msg');
/*
    props
    icon        (string) check, cancel, contact
    dark        (bool)
    icon        (bool)
    blue        (bool)
    green       (bool)
*/

class Button extends React.Component {

    constructor(props) {
        super(props);

        this.Container = styled.button `
            background-color: ${props => props.theme.colors.brand};
            color: #fff;
            cursor: pointer;
            box-shadow: inset 0 1px 2px rgba(255,255,255,0.25);
            border: 1px solid ${props => props.theme.colors.brand_dark};
            border-radius: ${props => props.theme.radius.general_ui};
            padding: 16px 60px;
            display: block;
            width: 100%;
            font-size: 16px;
            &.green{
                background-color: ${props => props.theme.colors.green[2]};
                border-color: ${props => props.theme.colors.green[1]};
                &:HOVER{
                    background-color: ${props => props.theme.colors.green[2]};
                }
            }
            &.blue{
                background-color: ${props => props.theme.colors.blue[2]};
                border-color: ${props => props.theme.colors.blue[1]};
                &:HOVER{
                    background-color: ${props => props.theme.colors.blue[2]};
                }
            }
            &.yellow{
                background-color: ${props => props.theme.colors.yellow[2]};
                border-color: ${props => props.theme.colors.yellow[1]};
                &:HOVER{
                    background-color: ${props => props.theme.colors.yellow[2]};
                }
            }
            &:disabled {
                background-color: ${props => props.theme.colors.disabled_input};
                border-color: ${props => props.theme.colors.disabled_input};
                cursor: not-allowed;
                &:HOVER {
                    background-color: ${props => props.theme.colors.disabled_input};
                }
            }
            &:HOVER {
                background-color: ${props => props.theme.colors.brand_dark};
            }
            &.dark{
                background-color: ${props => props.theme.colors.dark};
                border-color: ${props => props.theme.colors.dark_dark};
                &:HOVER{
                    background-color: ${props => props.theme.colors.dark_dark};
                }
            }
            &.icon{
                padding: 8px;
                border-radius: ${props => props.theme.radius.general_ui};
                width: auto;
                margin: auto;
                &.check{
                    background-color: ${props => props.theme.colors.green[2]};
                    border-color: ${props => props.theme.colors.green[1]};
                    &:HOVER{
                        background-color: ${props => props.theme.colors.green[1]};
                    }
                }
                &.cancel{
                    background-color: ${props => props.theme.colors.red[2]};
                    border-color: ${props => props.theme.colors.red[1]};
                    &:HOVER{
                        background-color: ${props => props.theme.colors.red[1]};
                    }
                }
                svg{
                    width: 34px;
                    height: 34px;
                }
            }
        `;
    }

    renderContent() {
        if (this.props.icon) {
            switch (this.props.icon) {
                case 'check':
                    return (<IconCheck/>);
                case 'cancel':
                    return (<IconCancel/>);
                case 'contact':
                    return (<IconContact/>);
                default:
                    return (<IconCheck/>);
            }

        }
        if (this.props.label) {
            return this.props.label;
        }
        return this.props.children;
    }

    render() {
        let classes = [];
        if (this.props.dark) {
            classes.push('dark');
        }
        if (this.props.green) {
            classes.push('green');
        }
        if (this.props.icon) {
            classes.push('icon');
            classes.push(this.props.icon);
        }
        if (this.props.blue) {
            classes.push('blue');
            classes.push(this.props.icon);
        }
        if (this.props.yellow) {
            classes.push('yellow');
            classes.push(this.props.icon);
        }

        return (
            <this.Container disabled={this.props.disabled || false} className={classes.join(' ')} onClick={this.props.onClick}>
                {this.renderContent()}
            </this.Container>
        );
    }
}

export default Button;



// WEBPACK FOOTER //
// ./src/components/base/Button.jsx